import styled from '@emotion/styled';

export const Container = styled.div`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
